const svgAnimatorIcon = (
  <svg
    id="eKlxjdS3INi1"
    viewBox="0 0 21 21"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
  >
    <g>
      <g>
        <polygon
          points="3424.3,424.1 3248.9,704.8 3424.3,985.5 3599.7,704.8"
          fill="none"
          stroke="#000"
          strokeWidth="35.0877"
          strokeMiterlimit="10"
        />
      </g>
      <g>
        <polyline
          points="3284,389 3091,704.8 3284,1020.6"
          fill="none"
          stroke="#000"
          strokeWidth="35.0877"
          strokeMiterlimit="10"
        />
      </g>
      <g>
        <g>
          <line
            x1="3143.6"
            y1="389"
            x2="3125.3"
            y2="418.9"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3107"
            y1="448.9"
            x2="3088.7"
            y2="478.8"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3070.4"
            y1="508.8"
            x2="3052.1"
            y2="538.7"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3033.8"
            y1="568.6"
            x2="3015.5"
            y2="598.6"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="2997.2"
            y1="628.5"
            x2="2978.9"
            y2="658.5"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3143.6"
            y1="1020.6"
            x2="3125.3"
            y2="990.6"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3107"
            y1="960.7"
            x2="3088.7"
            y2="930.8"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3070.4"
            y1="900.8"
            x2="3052.1"
            y2="870.9"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="3033.8"
            y1="840.9"
            x2="3015.5"
            y2="811"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="2997.2"
            y1="781.1"
            x2="2978.9"
            y2="751.1"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <polyline
            points="2960.6,721.2 2950.6,704.8 2960.6,688.4"
            fill="none"
            stroke="#f00"
            strokeWidth="35.0877"
            strokeMiterlimit="10"
          />
        </g>
      </g>
    </g>
    <g>
      <g>
        <polygon
          points="13.8,4.3 9.9,10.5 13.8,16.7 17.7,10.5"
          fill="none"
          stroke="#6B00DF"
          strokeWidth="0.7749"
          strokeMiterlimit="10"
        />
      </g>
      <g>
        <polyline
          points="10.7,3.5 6.4,10.5 10.7,17.5"
          fill="none"
          stroke="#6B00DF"
          strokeWidth="0.7749"
          strokeMiterlimit="10"
        />
      </g>
      <g>
        <g>
          <line
            x1="7.6"
            y1="3.5"
            x2="7.2"
            y2="4.2"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="6.8"
            y1="4.8"
            x2="6.4"
            y2="5.5"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="6"
            y1="6.2"
            x2="5.6"
            y2="6.8"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="5.2"
            y1="7.5"
            x2="4.8"
            y2="8.2"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="4.4"
            y1="8.8"
            x2="4"
            y2="9.5"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="7.6"
            y1="17.5"
            x2="7.2"
            y2="16.8"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="6.8"
            y1="16.2"
            x2="6.4"
            y2="15.5"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="6"
            y1="14.8"
            x2="5.6"
            y2="14.2"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="5.2"
            y1="13.5"
            x2="4.8"
            y2="12.8"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <line
            x1="4.4"
            y1="12.2"
            x2="4"
            y2="11.5"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <polyline
            points="3.6,10.9 3.3,10.5 3.6,10.1"
            fill="none"
            stroke="#6B00DF"
            strokeWidth="0.7749"
            strokeMiterlimit="10"
          />
        </g>
      </g>
    </g>
    <g>
      <g transform="translate(-19-10)">
        <path
          d="M36.7,11c1.1,0,2.3.9,2.3,2v15c0,1.1-.9,2-2,2h-15c-1.1,0-2-.9-2-2c.043221-3.980721.049226-11.486726,0-15c0-1.1.9-2,2-2h14.7Z"
          fill="none"
          stroke="#6B00DF"
          strokeWidth="1.5"
        />
      </g>
    </g>
  </svg>
);

export { svgAnimatorIcon };
